"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.policeDataUrl = exports.mapBoxUrl = exports.mapBoxToken = void 0;
// TODO: Have this be a env variable and update dynamically
exports.mapBoxToken = 'pk.eyJ1IjoicG9ubmFyYXNhbiIsImEiOiJja2p5YnNqeGcwN2EwMndwZDUzcmV1YXF4In0.DIEeanGhFnkvRPWnD5_iww';
exports.mapBoxUrl = 'https://api.mapbox.com/geocoding/v5';
exports.policeDataUrl = 'https://data.police.uk/api';
exports.default = {
    mapBoxToken: exports.mapBoxToken,
    mapBoxUrl: exports.mapBoxUrl,
    policeDataUrl: exports.policeDataUrl
};
//# sourceMappingURL=thirdpartytools.js.map